import { useQuery } from '@tanstack/react-query';
import {
  fetchAnalyticsSales,
  fetchAnalyticsTransactions,
  fetchAnalyticsProducts,
  fetchAnalyticsCustomers,
  fetchDashboardAnalytics,
} from './request';
import {
  ANALYTICS_SALES_QUERY_KEY,
  ANALYTICS_TRANSACTIONS_QUERY_KEY,
  ANALYTICS_PRODUCTS_QUERY_KEY,
  ANALYTICS_CUSTOMERS_QUERY_KEY,
  ANALYTICS_DASHBOARD_QUERY_KEY,
  ANALYTICS_RECENT_CHATS_QUERY_KEY,
} from './key';
import { fetchRecentChats } from './request';
import type { RecentChatChannel } from '@/types';

export const useAnalyticsSales = (startDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: [ANALYTICS_SALES_QUERY_KEY, startDate, endDate],
    queryFn: () => fetchAnalyticsSales(startDate, endDate),
  });
};

export const useAnalyticsTransactions = (
  startDate?: string,
  endDate?: string
) => {
  return useQuery({
    queryKey: [ANALYTICS_TRANSACTIONS_QUERY_KEY, startDate, endDate],
    queryFn: () => fetchAnalyticsTransactions(startDate, endDate),
  });
};

export const useAnalyticsProducts = (startDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: [ANALYTICS_PRODUCTS_QUERY_KEY, startDate, endDate],
    queryFn: () => fetchAnalyticsProducts(startDate, endDate),
  });
};

export const useAnalyticsCustomers = (startDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: [ANALYTICS_CUSTOMERS_QUERY_KEY, startDate, endDate],
    queryFn: () => fetchAnalyticsCustomers({ startDate, endDate }),
  });
};

export const useDashboardAnalytics = (startDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: [ANALYTICS_DASHBOARD_QUERY_KEY, startDate, endDate],
    queryFn: () => fetchDashboardAnalytics({ startDate, endDate }),
  });
};

export const useRecentChats = (channel: RecentChatChannel) => {
  return useQuery({
    queryKey: [ANALYTICS_RECENT_CHATS_QUERY_KEY, channel],
    queryFn: () => fetchRecentChats(channel),
  });
};
